const guidance = {
  heading: 'Components',
  body: [
    {
      chunk:
        "The power consumption of your satellite's components are assigned here. In Sedaro, a component can be a discrete power sink and heat dissipator (among other things) - such as a flight computer, radio, actuator, heater, etc.",
    },
  ],
};

export default guidance;
